<template>
  <div class="tender-bottom-nav">
    <div class="tender-bottom-nav__container">
      <div class="tender-bottom-nav__content">
        <div class="tender-bottom-nav__prev" data-test="previousTender" v-if="previousTender">
          <v-popover placement="top" trigger="hover" popoverClass="tender-bottom-nav__nav-tooltip">
            <BaseRoundButton @click.native="changePrevious(previousTender.id)" icon="chevron-left" is-outline />
            <template v-slot:popover>
              {{ $t('actions.previous') }}
              <div class="tender-header__shortcuts">
                <BaseShortcut isIcon value="arrow-left" />
              </div>
            </template>
          </v-popover>
        </div>

        <div v-if="nextTender">
          <span class="tender-bottom-nav__upper-text">{{ $t('bottom-nav-bar.next-tender') }}</span>
          <span class="tender-bottom-nav__title-truncated">
            <TextHighlight :content="nextTender.title"></TextHighlight>
          </span>
        </div>
        <div v-else-if="previousTender">
          <span class="tender-bottom-nav__upper-text">{{ $t('bottom-nav-bar.previous-tender') }}</span>
          <span class="tender-bottom-nav__title-truncated">
            <TextHighlight :content="previousTender.title"></TextHighlight>
          </span>
        </div>

        <div class="tender-bottom-nav__next" data-test="nextTender" v-if="nextTender">
          <v-popover placement="top" trigger="hover" popoverClass="tender-bottom-nav__nav-tooltip">
            <BaseRoundButton @click.native="changeNext(nextTender.id)" icon="chevron-right" is-outline />
            <template v-slot:popover>
              {{ $t('actions.next') }}
              <div class="tender-header__shortcuts">
                <BaseShortcut isIcon value="arrow-right" />
              </div>
            </template>
          </v-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextHighlight from '@/components/text-highlight/TextHighlight';
import BaseRoundButton from '@/components/base/BaseRoundButton';
import BaseShortcut from '@/components/base/BaseShortcut';
import { VPopover } from 'v-tooltip';

export default {
  name: 'TenderBottomNav',
  components: { BaseRoundButton, BaseShortcut, VPopover, TextHighlight },
  props: {
    tender: {
      type: Object,
      required: false,
    },
    previousTender: {
      type: Object,
      required: false,
    },
    nextTender: {
      type: Object,
      required: false,
    },
  },
  computed: {
    isMacOS() {
      return navigator.userAgent.toLowerCase().indexOf('mac') >= 0;
    },
  },
  methods: {
    changeNext(id) {
      this.$emit('change-next', id);
    },
    changePrevious(id) {
      this.$emit('change-previous', id);
    },
  },
};
</script>
<style lang="scss">
.tender-bottom-nav {
  align-items: center;
  background-color: $color-white;
  box-shadow: $shadow-dropdown, $shadow-default;
  border-radius: $border-radius-large;
  bottom: 32px;
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  margin: auto;
  height: $menu-top-bar-height;
  max-width: 600px;

  &__container {
    display: flex;
    flex: 1;
    justify-content: center;
    padding: 0 16px;
  }

  &__content {
    max-width: 560px;
    padding: 0 52px;
    position: relative;
    width: 100%;
  }

  &__prev {
    left: 0;
    position: absolute;
    top: calc(50% - 18px);
  }

  &__next {
    position: absolute;
    right: 0;
    top: calc(50% - 18px);
  }

  &__upper-text {
    color: $color-neutral;
    display: block;
    font-size: $font-size-xsmall;
    font-weight: bold;
  }

  &__title-truncated {
    color: $color-normal;
    display: block;
    font-size: $font-size-root;
    font-style: italic;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  &__nav-tooltip {
    padding: 8px;
    font-size: $font-size-xsmall;
    text-align: center;
    background-color: $color-normal !important;
    color: $color-white !important;
    box-shadow: $shadow-tooltip;
    max-width: 400px;

    .popover-arrow {
      background-color: $color-normal !important;
    }
  }
  @media screen and (max-width: 784px) {
    max-width: 350px;

    &__title-truncated {
      max-width: 200px;
    }
  }
}
</style>
